// 数字滚动指令（支持重复触发）
export default {
  bind(el, binding) {
    // 目标数值
    const target = Number(binding.value) || 0;
    // 元素是否可见的观察器
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        // 元素进入视口，执行滚动动画
        runCountUp(el, target);
      }
    });
    // 监听当前元素
    observer.observe(el);
    // 缓存观察器，方便销毁
    el._observer = observer;
    el._target = target; // 缓存目标值
  },
  unbind(el) {
    // 销毁观察器，避免内存泄漏
    if (el._observer) {
      el._observer.disconnect();
    }
    // 清除定时器
    if (el._timer) {
      clearInterval(el._timer);
    }
  },
};

// 独立的数字滚动函数（可复用）
function runCountUp(el, target) {
  // 清除之前的定时器，避免动画叠加
  if (el._timer) {
    clearInterval(el._timer);
  }
  // 重置初始值
  let current = 0;
  // 步长（可根据需要调整，越小越平滑）
  const step = target / 50;
  // 执行滚动
  el._timer = setInterval(() => {
    current += step;
    // 避免超过目标值
    if (current >= target) {
      current = target;
      clearInterval(el._timer);
      el._timer = null; // 清空定时器标记
    }
    // 更新显示的数值（取整）
    el.textContent = Math.floor(current);
  }, 16); // 约60帧/秒，更流畅
}
